import {
    trigger,
    transition, animate, style, state
} from '@angular/animations';

export const expansion = trigger('expansion', [
    state('true', style({ height: '*' })),
    state('false', style({ height: '0px', overflow: 'hidden' })),
    transition('false <=> true', animate(150))
]);
